export const fragSamplerMask = `
precision mediump float;

uniform sampler2D uSampler0;
uniform sampler2D uSampler1;
varying vec2 outTexCoord;
uniform int uInvertMaskAlpha;

void main ()
{
  vec4 mainColor = texture2D(uSampler0, outTexCoord);
  vec4 maskColor = texture2D(uSampler1, outTexCoord);

  float alpha = mainColor.a;

  if (uInvertMaskAlpha == 0)
  {
    alpha *= (maskColor.a);
  }
  else
  {
    alpha *= (1.0 - maskColor.a);
  }

  gl_FragColor = vec4(mainColor.rgb * alpha, alpha);
}
`;
